/**
 * 島根県 名物めし 12段階（コンテンツデータ）。
 *
 * 数値（radius / mass / score / unlockScore）は他県と同じテンプレート。
 * 12品すべてが農水省「うちの郷土料理」島根県の28品から採ってある。
 *
 * 形のばらつき。
 *  細長い（笹巻き・アゴの子・トビウオ・奉書焼き）／平たい（干し柿・白魚揚げ・角ずし・赤貝蒸し）／
 *  絡まって横に広がる（隠岐アラメ）／縦に積み重なる（割子そば）。
 *  器を描く例外は割子そばとうずめ飯の2品だけ。どちらも器が料理の本体なので外せない。
 *
 * 他県との重複。
 *  鯛・ふぐ・かに・ラーメン・牛・牡蠣・うなぎ・あなごは1品も使っていない。
 *  そばは割子そばのみ。福井のおろしそば、山形の板そばとは、丸い漆の重箱を縦に三段という形で分かれる。
 *
 * 調査で出てきた「書いてはいけないこと」を反映している。
 *  - 出雲大社の「日本最古の神社」、大社造の「日本最古の様式」はどちらも断定形の公的記述がない。
 *  - 大注連縄の「日本一」も使わない。長さ約13メートル、重さ5.2トンという数値だけを書く。
 *  - 出雲そばの「日本三大そば」は農水省自身が「数えられる」という伝聞形。使わない。
 *  - 白魚の「日本一」は江戸時代の評価の歴史叙述。現在形で書かない。
 *  - 中海の赤貝は農水省が「昭和30年代ごろまでは日本一の産地」と過去形。現在形で書かない。
 *  - 宍道湖のシジミは「全国トップクラス」。順位は年で変わるので書かない。
 *  - 割子が丸くなった理由、へかの語源、うずめ飯の由来はいずれも伝聞形。断定しない。
 *  - うずめ飯の「昭和14年に日本五大名飯のひとつに選定」は断定形なので書ける。
 *
 * 本番画像は public/assets/foods/shimane/ に置く。
 *
 * 2026-10-02 確定案（audit/_確定案.csv）で料理を入れ替えた。
 * - 外した品：干し柿（西条柿）・笹巻き・隠岐アラメの炒め煮・角ずし・赤貝のがらん蒸し・さざえ飯（店で食べられる品に差し替え）
 * - 赤天（あかてん）：考案した店名・考案者名は書かない（出典は「浜田のかまぼこ屋」としか書いておらず、店名を出すと宣伝になる）
 * - 赤天（あかてん）：赤い色が唐辛子によるとは書かない（出典は「赤い色をつけ、ピリ辛味に」とだけあり、着色の材料を明記していない）
 * - 赤天（あかてん）：「島根のソウルフード」は見出しにしない（出典の題にはあるが、説明文に必要ない）
 * - 出雲ぜんざい：「ぜんざい発祥の地」は言い切らない（出典が「〜といわれています」「記載されています」と書いている範囲で、伝聞形の豆知識としてだけ書いた）
 * - 出雲ぜんざい：紅白の餅は書かない（紅白餅入りの商品・店はあるが、観光協会・県の公式ページで出雲ぜんざいの定義として確かめられなかった。絵も白い餅2つ）
 * - 出雲ぜんざい：汁が多いことは書かない（「汁を多めに」は運営者の分からないサイトにしか見当たらなかった）
 * - しじみ汁：漁獲量の順位（「国内トップレベル」）は書かない（年によって変わり、見出しに使う必要もない）
 * - しじみ汁：「シジミは水からヒトクラ」という言い伝えは書いたほうがよいが、字数の都合で入れていない（出典にはある）
 * - 「白魚のかき揚げ」を「白魚の天ぷら」に改め、絵と説明を描き直した（同じ料理なので ID は shirauo-kakiage のまま）。
 * - 白魚の天ぷら：「白魚の天ぷら」としての作り方（一尾ずつ揚げる）は出典に明記がない。出典は天ぷらにすると書くだけなので、見出し以外で衣の付け方を細かく書かない
 * - 白魚の天ぷら：「日本一の評判」（農水省ページの江戸時代の記述）は書かない（称号として使わない）
 * - 隠岐のさざえ丼：「さざえ丼発祥の店」は書かない（店名が出るうえ、自治体資料で裏が取れない）
 * - 隠岐のさざえ丼：店名（卵とじの店の名前）は書かない
 * - 隠岐のさざえ丼：玉ねぎを入れることは書かない（出典に記述がない）
 * - のどぐろの塩焼き：「日本海の赤い宝石」は書かない（浜田市のページにある呼び名だが、見出しに使うと宣伝調になる。使うなら「〜と呼ばれる」で）
 * - のどぐろの塩焼き：塩焼きの作り方は書かない（公式ページで塩焼きの記述を確かめられなかった）
 * - しまね和牛：「肉質日本一」は書かない（公式ページで確かめていない）
 * - しまね和牛：但馬牛・神戸牛のもと牛だったという話は書かない（出典自身が「と言われています」と伝聞で、他県のブランド名を出す必要がない）
 */

import { attachHulls } from '../../utils/itemShape';
import type { RewardLink, StageDefinition, StageItemDefinition } from '../types';

import { shimaneSceneryTour } from './shimaneScenes';
import { SHIMANE_FOOD_HULLS } from './shimaneFoodShapes.generated';

/** 「食べに行く」導線の既定リンク（特定店の宣伝にならないよう検索リンクにする）。 */
function searchLinks(area: string, dish: string): RewardLink[] {
  return [
    {
      label: '地図で探す',
      url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${area} ${dish}`)}`,
    },
    {
      label: 'お店を調べる',
      url: `https://www.google.com/search?q=${encodeURIComponent(`${area} ${dish}`)}`,
    },
  ];
}

const FOOD_ITEMS: StageItemDefinition[] = [
  {
    id: 'akaten',
    level: 1,
    name: '赤天（あかてん）',
    shortName: '赤天',
    image: '/assets/foods/shimane/01_akaten.webp',
    radius: 17,
    mass: 1,
    score: 2,
    description: '魚のすり身を練った蒲鉾に赤い色をつけてピリ辛に仕上げ、パン粉をつけて揚げる。衣はサクサクとした歯ざわり。戦後、浜田のかまぼこ屋が、食べ物の乏しい時代にもおいしい練り物をと考えて作った。',
    source:
      'https://www.kankou-shimane.com/bihadaken-uruoi/report/souvenir/41/',
    icon: { label: '赤天', shape: 'mochi', baseColor: '#d9472b', accentColor: '#f3e6d0' },
    reward: {
      unlockScore: 200,
      area: '浜田市',
      headline: 'パン粉をまとった赤い蒲鉾',
      tip: '地元では少し炙ってから、マヨネーズをつけて食べるのが定番。いまでは県内のほぼすべてのスーパーに並ぶ。',
      links: searchLinks('浜田市', '赤天'),
      official: [{ label: 'しまね観光ナビ「浜田のソウルフード」', url: 'https://www.kankou-shimane.com/bihadaken-uruoi/report/souvenir/41/' }],
    },
  },
  {
    id: 'izumo-zenzai',
    level: 2,
    name: '出雲ぜんざい',
    shortName: '出雲ぜんざい',
    image: '/assets/foods/shimane/02_izumo_zenzai.webp',
    radius: 21,
    mass: 1.3,
    score: 4,
    description: '小豆を甘く煮た汁に、やわらかい餅を入れる。出雲では神在祭のときに「神在餅（じんざいもち）」をふるまっていた。その「じんざい」が出雲弁でなまって「ずんざい」、さらに「ぜんざい」になったといわれる。',
    source:
      'https://izumo-kankou.gr.jp/6404',
    icon: { label: 'ぜんざい', shape: 'mochi', baseColor: '#6b2a3a', accentColor: '#fbf7f0' },
    reward: {
      unlockScore: 500,
      area: '出雲市',
      headline: '神在餅がなまってぜんざいに',
      tip: 'ぜんざい発祥の地が出雲であることは、江戸初期の文献『祇園物語』や『梅村載筆』、『雲陽誌』に記されているとされる。',
      links: searchLinks('出雲市', '出雲ぜんざい'),
      official: [{ label: '出雲観光協会「神在月」', url: 'https://izumo-kankou.gr.jp/6404' }, { label: 'しまね観光ナビ「出雲地方が発祥。心とからだを芯から温める和の甘味」', url: 'https://www.kankou-shimane.com/bihadaken-uruoi/report/food/249/' }],
    },
  },
  {
    id: 'shijimi-jiru',
    level: 3,
    name: 'しじみ汁',
    shortName: 'しじみ汁',
    image: '/assets/foods/shimane/03_shijimi_jiru.webp',
    radius: 26,
    mass: 1.7,
    score: 8,
    description: '宍道湖でとれる大粒のヤマトシジミを、昆布と水から中火で煮て、口が開いたら味噌を溶く。煮すぎないのがこつ。出雲地方では毎日の食卓にのぼる汁物として根づいている。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/shijimijiru_shimane.html',
    icon: { label: 'しじみ汁', shape: 'pot', baseColor: '#b88a55', accentColor: '#1e1e1e' },
    reward: {
      unlockScore: 1000,
      area: '松江市ほか出雲地方（宍道湖周辺）',
      headline: '宍道湖の大粒しじみを汁に',
      tip: '土用に飲むしじみ汁は夏ばて予防とされた。冬は味噌汁、夏はすまし汁にして食べてきた。',
      links: searchLinks('松江市', 'しじみ汁'),
      official: [{ label: 'しまね観光ナビ「宍道湖七珍」', url: 'https://www.kankou-shimane.com/destination/20527' }],
    },
  },
  {
    id: 'shirauo-kakiage',
    level: 4,
    name: '白魚の天ぷら',
    shortName: '白魚の天ぷら',
    image: '/assets/foods/shimane/04_shirauo_kakiage.webp',
    radius: 30,
    mass: 2.2,
    score: 16,
    description: '宍道湖でとれる半透明の小さな白魚を、薄い衣で揚げる。白魚は宍道湖七珍のひとつで、天ぷらやすまし汁にするほか、生のまま酢味噌で食べることもある。',
    source:
      'https://www.kankou-shimane.com/destination/20527',
    icon: { label: '白魚天', shape: 'fish', baseColor: '#f1e2b8', accentColor: '#c9a24a' },
    reward: {
      unlockScore: 1800,
      area: '松江市（宍道湖）',
      headline: '宍道湖の白魚を一尾ずつ揚げる',
      tip: '宍道湖では主に11月から5月にとる。「春を告げる魚」として親しまれ、地元には「食べなければ春が来ない」という人もいる。',
      links: searchLinks('松江市', '白魚の天ぷら'),
      official: [{ label: '農林水産省「うちの郷土料理」白魚のかき揚げ', url: 'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/shirauonokakiage_shimane.html' }],
    },
  },
  {
    id: 'ago-no-ko',
    level: 5,
    name: 'アゴの子旨煮',
    shortName: 'アゴの子',
    image: '/assets/foods/shimane/05_ago_no_ko.webp',
    radius: 36,
    mass: 2.8,
    score: 32,
    description: '粒が大きく、ねっとりとほどけない。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/agonokoumani_shimane.html',
    icon: { label: 'アゴの子', shape: 'roe', baseColor: '#b07830', accentColor: '#e8c878' },
    reward: {
      unlockScore: 3000,
      area: '隠岐地域',
      headline: '島根ではトビウオをアゴと呼ぶ。その卵を生姜を効かせた煮汁でさっと煮ふくめる。',
      tip: '卵は粒が大きく皮もややかたく、一粒ずつがほぐれにくい。水と生姜のうす切りを入れ、沸いたら中火で5分ほど煮る。',
      links: searchLinks('隠岐', 'アゴの子 旨煮'),
    },
  },
  {
    id: 'tobiuo-sashimi',
    level: 6,
    name: 'トビウオの刺身',
    shortName: 'トビウオ',
    image: '/assets/foods/shimane/06_tobiuo_sashimi.webp',
    radius: 42,
    mass: 3.5,
    score: 64,
    description: '空を滑空する魚が、島根県の魚。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/tobiuonosashimi_shimane.html',
    icon: { label: 'トビウオ', shape: 'fish', baseColor: '#3a6a90', accentColor: '#e0e8ee' },
    reward: {
      unlockScore: 4500,
      area: '東部地域・隠岐地方',
      headline: '平成元年に島根県の魚に指定されたトビウオを、鮮度のよいうちに刺身にする。',
      tip: '身は筋肉質で脂がほとんどなく、淡白で上品。十数メートル空中を滑空することもある。長いヒレとうろこをしっかり取ってから調理する。',
      links: searchLinks('島根県', 'トビウオ 刺身'),
    },
  },
  {
    id: 'warigo-soba',
    level: 7,
    name: '出雲そば（割子そば）',
    shortName: '割子そば',
    image: '/assets/foods/shimane/07_warigo_soba.webp',
    radius: 46,
    mass: 4.4,
    score: 128,
    description: '黒いそばを、丸い重箱に三段重ねて。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/izumosoba_shimane.html',
    icon: { label: '割子そば', shape: 'noodle-bowl', baseColor: '#7a2a20', accentColor: '#4a4038' },
    reward: {
      unlockScore: 6500,
      area: '出雲地方',
      headline: '玄そばを殻ごと挽く挽きぐるみの黒いそばを、丸い重箱「割子」に三段重ねて出す。',
      tip: '殻のついたそばの実をそのまま挽き込むため色が黒く、香りが強い。つなぎの小麦粉は2割ほど。上の段から薬味と出汁をかけて食べる。',
      links: searchLinks('出雲市', '割子そば'),
    },
  },
  {
    id: 'uzume-meshi',
    level: 8,
    name: 'うずめ飯',
    shortName: 'うずめ飯',
    image: '/assets/foods/shimane/08_uzume_meshi.webp',
    radius: 51,
    mass: 5.4,
    score: 256,
    description: '掘ると出てくる、隠れたごちそう。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/uzumemeshi_shimane.html',
    icon: { label: 'うずめ飯', shape: 'rice-bowl', baseColor: '#e8dcc0', accentColor: '#8ab04a' },
    reward: {
      unlockScore: 9000,
      area: '石見地方（浜田市・益田市・津和野町など）',
      headline: '一見ただの茶漬けに見えて、ご飯の下に刻んだ魚や野菜が隠れている石見地方のご飯もの。',
      tip: 'ご飯の下にタイ、せり、人参、ごぼう、椎茸、里芋、豆腐などを小さく刻んで沈め、出汁をかけてわさびをそえる。昭和14年に日本五大名飯のひとつに選ばれている。',
      links: searchLinks('島根県石見地方', 'うずめ飯'),
    },
  },
  {
    id: 'oki-sazae-don',
    level: 9,
    name: '隠岐のさざえ丼',
    shortName: 'さざえ丼',
    image: '/assets/foods/shimane/09_oki_sazae_don.webp',
    radius: 57,
    mass: 6.6,
    score: 512,
    description: '隠岐で一年じゅう豊富にとれるサザエを、どんぶりにする。島の日常ともいえるサザエを知ってもらおうと始まり、店ごとに9種類が生まれた。隠岐の島町には、だしを含んだ卵でとじたさざえ丼がある。',
    source:
      'https://www.e-oki.net/features/6474/',
    icon: { label: 'さざえ丼', shape: 'rice-bowl', baseColor: '#f0c54a', accentColor: '#5a4a2a' },
    reward: {
      unlockScore: 12000,
      area: '隠岐の島町／西ノ島町',
      headline: '島のサザエを卵でとじる',
      tip: 'サザエの旬は春から初夏。ご飯と一緒に食べると磯の香りが口いっぱいに広がる、と島の観光案内は紹介している。',
      links: searchLinks('隠岐の島町', 'さざえ丼'),
      official: [{ label: '隠岐の島旅「隠岐を代表する10の食材」', url: 'https://www.e-oki.net/features/6424/' }],
    },
  },
  {
    id: 'nodoguro-shioyaki',
    level: 10,
    name: 'のどぐろの塩焼き',
    shortName: 'のどぐろ塩焼き',
    image: '/assets/foods/shimane/10_nodoguro_shioyaki.webp',
    radius: 63,
    mass: 8,
    score: 1024,
    description: '標準和名はアカムツ。口の中が黒いことからのどぐろと呼ばれる。白身で、口の中でとろけるほど脂が乗り、多いもので脂質は25〜30%に達して「白身魚のトロ」といわれる。浜田市の市の魚。',
    source:
      'https://kankou-hamada.or.jp/content/fish/nodoguro/',
    icon: { label: 'のどぐろ', shape: 'fish', baseColor: '#d94a3a', accentColor: '#f2f2ec' },
    reward: {
      unlockScore: 16000,
      area: '浜田市',
      headline: '白身魚のトロと呼ばれる赤い魚',
      tip: '浜田港で水揚げされた80g以上のものは「どんちっちノドグロ」の名で出す。どんちっちは神楽の囃子を表す幼児言葉で、石見神楽全体を指すようになった。',
      links: searchLinks('浜田市', 'のどぐろ 塩焼き'),
      official: [{ label: '浜田市「浜田の水産ブランド“どんちっち”」', url: 'https://www.city.hamada.shimane.jp/www/contents/1001000003192/index.html' }],
    },
  },
  {
    id: 'shimane-wagyu',
    level: 11,
    name: 'しまね和牛',
    shortName: 'しまね和牛',
    image: '/assets/foods/shimane/11_shimane_wagyu.webp',
    radius: 70,
    mass: 9.6,
    score: 2048,
    description: '島根県で育った去勢・未経産の黒毛和種をしまね和牛と呼ぶ。出雲の山あいでは古くからたたら製鉄が盛んで、鉄を運ぶ牛馬が欠かせなかったことから牧畜が育った。すき焼きでは霜降りが口の中でほどける。',
    source:
      'https://www.kankou-shimane.com/gourmet/wagyu',
    icon: { label: '和牛', shape: 'hotpot', baseColor: '#b5523f', accentColor: '#f0d9c8' },
    reward: {
      unlockScore: 22000,
      area: '島根県全域',
      headline: 'たたら製鉄の牛から育った和牛',
      tip: '5年ごとに開かれる全国和牛能力共進会で、2度の内閣総理大臣賞を受けている。島根の子牛は温順で、かつては各地へ出荷された。',
      links: searchLinks('島根県', 'しまね和牛 すき焼き'),
      official: [{ label: 'しまね和牛肉ブランド確立推進協議会', url: 'https://www.shimane-wagyu.org/' }],
    },
  },
  {
    id: 'hosho-yaki',
    level: 12,
    name: 'スズキの奉書焼き',
    shortName: '奉書焼き',
    image: '/assets/foods/shimane/12_hosho_yaki.webp',
    radius: 78,
    mass: 11.4,
    score: 4096,
    description: '紙に包んだまま焼き、紙ごと運ぶ。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/suzukinohoshoyaki_shimane.html',
    icon: { label: '奉書焼き', shape: 'feast', baseColor: '#efe8d8', accentColor: '#b08040' },
    reward: {
      unlockScore: 30000,
      area: '松江市',
      headline: '塩をしたスズキを濡らした奉書紙で幾重にも包み、紙ごと蒸し焼きにする松江のハレの料理。',
      tip: 'うろことエラを取り、つぼ抜きで内臓を出して全体に塩を振る。濡らした奉書紙で二、三重に包んで天火で蒸し焼きにし、もみじおろしや醤油で食べる。',
      links: searchLinks('松江市', '奉書焼き'),
    },
  },
];

/** 得点は 2 ^ level を基準にしている（GAME_TUNING.score で方式変更可能）。 */
export const shimaneFoodStage: StageDefinition = {
  regionId: 'shimane',
  regionName: '島根県',
  mode: 'food',
  title: '島根めしマージ',
  theme: {
    primaryColor: '#3a4a6a',
    secondaryColor: '#c8a860',
    accentColor: '#e0c880',
    backgroundColor: '#141620',
  },
  /** 背景ツアー「島根めぐり」。軸は一日の時間。夜明けの稲佐の浜から、夜の日御碕灯台へ。 */
  scenery: {
    tour: shimaneSceneryTour,
  },
  items: attachHulls(FOOD_ITEMS, SHIMANE_FOOD_HULLS),
};
